import { useStore } from 'effector-react'
import React, { useEffect } from 'react'
import { $strategyEdit, strategyEditMounted, updateStrategy } from './model'

export const useStrategyEdit = () => {
  const strategyEdit = useStore($strategyEdit)
  const loading = useStore(updateStrategy.pending)

  useEffect(() => {
    strategyEditMounted()
  }, [])

  return { strategyEdit, loading }
}
